module.exports = __webpack_public_path__ + "static/media/home-changing-5.d40e4d2f.jpg";